import { render } from "./App.vue?vue&type=template&id=734173f6"
const script = {}

import exportComponent from "C:\\onetap\\onetap\\frontend\\tntlandingpage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__